/** Brief save-celebration pulse with coach sentence. Skips animation when prefers-reduced-motion is set. */

import { useEffect, useRef } from 'react';

export interface SaveCelebrationProps {
  sentence: string;
  onDismiss?: () => void;
}

export function SaveCelebration({ sentence, onDismiss }: SaveCelebrationProps): JSX.Element {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (reduced || !cardRef.current) return;
    const el = cardRef.current;
    el.classList.add('scale-105');
    const t = setTimeout(() => {
      el.classList.remove('scale-105');
      el.classList.add('scale-100');
    }, 220);
    return () => clearTimeout(t);
  }, [reduced]);

  return (
    <div
      ref={cardRef}
      role="status"
      aria-live="polite"
      className="transition-transform duration-200 ease-out flex flex-col items-center gap-4 py-8 px-6 text-center"
    >
      {/* checkmark icon */}
      <span className="flex items-center justify-center w-16 h-16 rounded-full bg-accent/20 text-accent text-4xl select-none">
        ✓
      </span>

      <p className="text-lg font-semibold text-foreground">Logged!</p>

      <p className="text-sm text-muted-foreground max-w-xs">{sentence}</p>

      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="mt-2 text-xs text-accent underline underline-offset-2 hover:text-accent/80 transition-colors"
        >
          Log another
        </button>
      )}
    </div>
  );
}
